export { Carousel as default } from './carousel'
export type { CarouselProps } from './carousel'
